<template>
  <div class="custom-font-regular">
    <ConfirmationDialog ref="confirm" :function-yes="bindingFunction"></ConfirmationDialog>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Evento</v-toolbar-title>
    </v-toolbar>
    <v-container grid-list-md mt-5 pt-5>
      <template v-if="isCanceled">
        <v-alert :value="true" type="error" icon="highlight_off" class="custom-alert custom-font-regular">
          Evento cancelado
        </v-alert>
      </template>
      <template v-if="assist">
        <v-alert :value="true" type="success" icon="check_circle_outline" class="custom-alert custom-font-regular"
                 v-if="isGoing && !isCanceled">Asistirás a este evento</v-alert>
        <v-alert :value="true" type="error" icon="highlight_off" class="custom-alert custom-font-regular"
                 v-if="isNotGoing && !isCanceled">No asistirás a este evento</v-alert>
        <v-alert :value="true" type="warning" icon="help_outline" class="custom-alert custom-font-regular"
                 v-if="isDontKnow && !isCanceled">No sabes si asistirás a este evento</v-alert>
      </template>
      <v-toolbar class="header-element">
        <v-toolbar-title>{{ event.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <div v-if="assist && !isCanceled">
          <v-btn small color="primary darken-1" :outline="isGoing" @click="changeAssist('yes')" :disabled="saving"
                 :class="['white--text', 'mr-0', 'button-text', {'button-selected': isGoing}]">
            <span>Asistiré</span>
          </v-btn>
          <v-btn small color="primary darken-1" :outline="isNotGoing" @click="changeAssist('no')" :disabled="saving"
                 :class="['white--text', 'mx-0', 'button-text', {'button-selected': isNotGoing}]">
            <span>No asistiré</span>
          </v-btn>
          <v-btn small color="primary darken-1" :outline="isDontKnow" @click="changeAssist('idk')" :disabled="saving"
                 :class="['white--text', 'ml-0', 'button-text', {'button-selected': isDontKnow}]">
            <span>No sé</span>
          </v-btn>
        </div>
        <template v-if="$store.getters.isSafRole && event.canEdit">
          <v-btn class="button-change" color="primary" @click="updateEvent" :disabled="isCanceled">
            <span>Reprogramar</span>
          </v-btn>
          <v-btn class="button-cancel" color="red lighten-2" @click="cancelEvent" :disabled="isCanceled">
            <span>Cancelar</span>
          </v-btn>
        </template>
      </v-toolbar>
      <v-card>
        <v-layout row wrap>
          <v-flex sm3 xs12>
            <v-subheader>Fecha</v-subheader>
            <v-card-title>{{ event.fecha }}</v-card-title>
          </v-flex>
          <template v-if="$vuetify.breakpoint.smAndUp">
            <v-divider vertical></v-divider>
          </template>
          <template v-else>
            <v-flex ma-1 pa-0><v-divider></v-divider></v-flex>
          </template>
          <v-flex sm8 xs12>
            <v-subheader>Ubicación</v-subheader>
            <v-card-title>{{ event.ubicacion }}</v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-subheader>Descripción</v-subheader>
        <v-card-title>
          <pre class="text-formatted custom-font-regular">{{ event.description }}</pre>
        </v-card-title>
        <template v-if="event.assets && event.assets.length">
          <v-divider></v-divider>
          <v-subheader>Adjuntos</v-subheader>
          <v-card-text v-for="asset in event.assets" :key="asset.pk" class="pt-2">
            <a :href="asset.url" target="_blank">{{ getAttachmentName(asset.name) }}</a>
            <span v-if="asset.description" class="grey--text">: <i>{{ asset.description }}</i></span>
          </v-card-text>
        </template>
      </v-card><br>
      <v-layout row wrap v-if="$store.getters.isSafRole">
        <GuestList listName="Asistirán" :guests="event.going" icon="check_circle_outline"></GuestList>
        <GuestList listName="No asistirán" :guests="event.notGoing" icon="highlight_off"></GuestList>
        <GuestList listName="No saben" :guests="event.unconfirmed" icon="help_outline"></GuestList>
        <GuestList listName="A confirmar" :guests="event.unanswered" icon="block"></GuestList>
      </v-layout>
      <GoBackButton/>
    </v-container>
  </div>
</template>

<script>
import GuestList from '../components/GuestList'
import GoBackButton from '../../../common/ui/GoBackButton'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'

const ASSISTANCE_CHOICES = {
  'yes': 1,
  'no': 2,
  'idk': 3,
  'notConfirmed': 4
}
const ASSISTANCE_KEYS = ['', 'yes', 'no', 'idk', 'notConfirmed']

export default {
  components: {
    GuestList,
    GoBackButton,
    ConfirmationDialog
  },

  data () {
    return {
      event: {},
      canceledEventStatus: 0,
      availableEventStatus: 1,
      bindingFunction: null,
      loading: false,
      saving: false,
      assist: null,
      date: null,
      time: null,
      cancelPath: 'event/edit'
    }
  },

  computed: {
    isGoing () {
      return this.assist === 'yes'
    },
    isNotGoing () {
      return this.assist === 'no'
    },
    isDontKnow () {
      return this.assist === 'idk'
    },
    isCanceled () {
      return this.event.status === this.canceledEventStatus
    }
  },

  methods: {
    setData (data) {
      this.title = data.title
      this.endDate = this.formatDate(data.endDate)
      this.asset = data.asset
      if (this.$route.params.hasOwnProperty('extend')) {
        if (this.$route.params.extend !== null) {
          this.extend = true
          this.inputDate(this.$route.params.extend)
        }
      }
    },
    fetchData () {
      this.axios
        .get(`event/${this.$route.params.id}`)
        .then(response => {
          this.event = response.data
          this.assist = (response.data.assist) ? ASSISTANCE_KEYS[response.data.assist.asistenciaCode] : null
          this.loading = false
          this.saving = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.saving = false
        })
    },
    changeAssist (option) {
      if (this.assist !== option) {
        this.assist = option
        this.saving = true
        let payload = { 'asistencia': ASSISTANCE_CHOICES[option] }
        this.axios
          .post(`event/assist/${this.$route.params.id}`, payload)
          .then(() => {
            this.fetchData()
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
          })
      }
    },
    getAttachmentName (attachment) {
      return attachment.split('/').slice(-1).pop()
    },
    updateEvent () {
      this.$router.push({ name: 'editarEvento', params: this.event })
    },
    getPayload () {
      this.date = `${this.event.year}-${this.event.month}-${this.event.day}`
      let hour = this.event.fecha
      this.time = hour.split(' ')[1]
      return {
        'status': this.event.status,
        'title': this.event.title,
        'ubicacion': this.event.ubicacion,
        'horario': `${this.date} ${this.time}`,
        'definiciones_criterio': this.event.criteriosPersona.map(function (criterio) { return criterio.id }),
        'clubes': this.event.clubes.map(function (club) { return club.pk }),
        'emails': this.event.emails
      }
    },
    cancelEvent () {
      this.bindingFunction = () => {
        this.event.status = this.canceledEventStatus
        const payload = this.getPayload()
        this.axios
          .put(`${this.cancelPath}/${this.event.pk}`, payload)
          .then(() => {
            this.saving = false
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
            this.event.status = this.availableEventStatus
          })
      }
      this.$refs.confirm.openDialog()
    }
  },

  created () {
    this.fetchData()
  }
}
</script>

<style scoped>
.header-element {
  background-color: #293968;
  color: white;
}
.button-change {
  font-size: 1em;
  font-weight: bold;
  float: right;
}
.button-cancel {
  color: white;
  font-weight: bold;
}
pre {
  line-height: 1.5;
}
.custom-alert{
  height: 50px;
  font-size: 1.1em;
}
</style>
